import React, { createContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { conectarSocketUsuario } from '../utils/socket';
import { addSocketMessage, getChats } from '../actions/chat';
import { getNotifications, addNotification } from '../actions/notification';
import { UPDATE_ONLINE_USERS } from '../actions/types';

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const dispatch = useDispatch();
    const socket = useRef();
    // El contexto entrega el socket desde el estado, no desde el ref: asignar `socket.current` no
    // re-renderiza, así que los consumidores (p. ej. el chat de soporte) se quedaban con `undefined`
    // y nunca se suscribían a los eventos.
    const [socketActivo, setSocketActivo] = useState(null);
    const { isAuthenticated } = useSelector(state => state.auth);
    const authUser = useSelector(state => state.auth.user || state.user.user);
    const user = authUser;

    useEffect(() => {
        if (isAuthenticated && user && user._id) {
            // Conectar si no existe
            if (!socket.current) {
                // El token de la sesión viaja en la conexión: el servidor decide a qué sala entras
                socket.current = conectarSocketUsuario();
                setSocketActivo(socket.current);

                socket.current.on('connect', () => {
                    console.log('Socket connected:', socket.current.id);
                    // El servidor nuevo ya te une a tu sala con el token e ignora este id; se conserva por si el
                    // backend desplegado todavía es el anterior.
                    socket.current.emit('join', user._id);
                });

                socket.current.on('notification', (notif) => {
                    dispatch(addNotification(notif));
                });

                socket.current.on('new_message', (data) => {
                    console.log('New socket message received:', data);
                    dispatch(addSocketMessage(data.message, data.chatId, user._id));
                });

                socket.current.on('update_online_users', (userIds) => {
                    console.log('Online users update:', userIds);
                    dispatch({
                        type: UPDATE_ONLINE_USERS,
                        payload: userIds
                    });
                });

                // Cargar datos iniciales
                dispatch(getChats());
                dispatch(getNotifications());
            } else {
                // Si ya existe el socket pero cambió el usuario, nos volvemos a unir
                socket.current.emit('join', user._id);
            }
        }

        return () => {
            if (socket.current && !isAuthenticated) {
                socket.current.disconnect();
                socket.current = null;
                setSocketActivo(null);
            }
        };
    }, [isAuthenticated, user, dispatch]);

    return (
        <SocketContext.Provider value={socketActivo}>
            {children}
        </SocketContext.Provider>
    );
};
